import React from "react";

const StageContext = React.createContext({});

export default StageContext;
